import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';

@Injectable({ providedIn: 'root' })
export class ApiParkingDashboardService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getParkingDashboard(params: {
    siteId: number;
    startDate: string;
    endDate: string;
  }): Observable<unknown> {
    return this.apiMethodService.request('/FinanceReports/getParkingDashboard', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getParkingDashboard',
      token: this.token,
      headerOnly: false,
      params: {
        siteId: params.siteId,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    });
  }

  getParkingOpsDashboard(params: {
    siteId: number;
    startDate: string;
    endDate: string;
  }): Observable<unknown> {
    return this.apiMethodService.request('/FinanceReports/getParkingOpsDashboard', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getParkingOpsDashboard',
      token: this.token,
      headerOnly: false,
      params: {
        siteId: params.siteId,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    });
  }

  getParkingFinanceDashboard(params: {
    siteId: number;
    startDate: string;
    endDate: string;
  }): Observable<unknown> {
    return this.apiMethodService.request('/FinanceReports/getParkingFinanceDashboard', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getParkingFinanceDashboard',
      token: this.token,
      headerOnly: false,
      params: {
        siteId: params.siteId,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    });
  }
}
